import { IconButton, IconClose16, UIText1 } from '@cian/ui-kit';
import { UIText2 } from '@cian/ui-kit/typography';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './OfferPreviewError.css';

export interface IOfferPreviewErrorProps {
  className?: string;
  isCompact?: boolean;
  onClose(): void;
  onRetry(): void;
}

export const OfferPreviewError = ({ className, isCompact = false, onClose, onRetry }: IOfferPreviewErrorProps) => {
  return (
    <div
      data-testid="OfferPreviewError"
      className={cn(styles['root'], isCompact && styles['root--compact'], className)}
    >
      <div className={styles['close-button']}>
        <IconButton onClick={onClose} icon={<IconClose16 />} />
      </div>
      <span className={styles['error-message']}>
        <UIText2 textAlign="center" display="block">
          Не удаётся загрузить объявление
        </UIText2>
      </span>
      <button className={styles['refresh-button']} type="button" onClick={onRetry} title="Обновить">
        <UIText1 color="primary_100">Обновить</UIText1>
      </button>
    </div>
  );
};

OfferPreviewError.displayName = 'OfferPreviewError';
